<template>
    <div>
        <limitless-page-header title="NTAPS" sub-title="Fraktsedelsutskrift">
            <template #header-elements>
                <limitless-page-header-button v-if="order_route" icon="icon-circle-left2" :route="order_route">Tillbaka till order</limitless-page-header-button>
            </template>
        </limitless-page-header>

        <div class="content">
            <b-card no-body class="mb-3" v-if="hasRole('super-admin')">
                <b-card-header header-bg-variant="light">
                    <b-card-title title-tag="h5" v-b-toggle.collapse-debug>Debug</b-card-title>
                </b-card-header>
                <b-collapse id="collapse-debug">
                    <pre v-html="print_job" class="border-0"></pre>
                </b-collapse>
            </b-card>

            <form @submit.prevent="printLabel">
                <ValidationObserver ref="printlabelform">
                    <b-card no-body v-for="(shipment, s_index) in print_job.shipments" :key="'s-' + s_index">
                        <template v-if="shipment.tos_id">
                            <b-card-header header-bg-variant="light" class="header-elements-inline py-2">
                                <b-card-title title-tag="h5">TOS: {{ shipment.tos_id }}</b-card-title>
                            </b-card-header>
                        </template>
                        <template v-else>
                            <b-card-header header-bg-variant="light" class="header-elements-inline py-2">
                                <b-card-title title-tag="h5">Sändning<span v-if="print_job.shipments.length > 1"> {{ s_index + 1 + ' av ' + print_job.shipments.length }}</span></b-card-title>
                            </b-card-header>
                            <b-card-body>
                                <b-row>
                                    <b-col cols="6">
                                        <ValidationProvider
                                            :vid="'shipments.' + s_index + '.service_type'"
                                            v-slot="{ errors }"
                                            tag="div"
                                            rules="required"
                                            name="Fraktsätt"
                                        >
                                            <b-form-group
                                                :invalid-feedback="errors[0]"
                                                :state="!errors.length"
                                                label="Fraktsätt"
                                                :class="{'has-validation-error': !!(errors[0]) }"
                                            >
                                                <v-select
                                                    placeholder="-- Välj fraktsätt --"
                                                    :options="service_types"
                                                    label="name"
                                                    :getOptionLabel="(opt) => {
                                                        if (opt.ui_json && opt.ui_json.name) {
                                                            return opt.ui_json.name;
                                                        }
                                                        return opt.name;
                                                    }"
                                                    v-model="service_type[s_index]"
                                                    :disabled="busy_printing"
                                                    @option:selected="setServiceType(s_index)"
                                                    @option:deselected="setServiceType(s_index)"
                                                />
                                            </b-form-group>
                                        </ValidationProvider>
                                        <ValidationProvider
                                            :vid="'shipments.' + s_index + '.sender_tag'"
                                            v-slot="{ errors }"
                                            tag="div"
                                            rules="required"
                                            name="Avsändare"
                                        >
                                            <b-form-group
                                                :invalid-feedback="errors[0]"
                                                :state="!errors.length"
                                                label="Avsändare"
                                                :class="{'has-validation-error': !!(errors[0]) }"
                                            >
                                                <ntaps-senders-filter
                                                    v-model="print_job.shipments[s_index].sender_tag"
                                                    :reduce="(opt) => opt.tag"
                                                    :disabled="busy_printing"
                                                    :delivery-service-id="service_type[s_index] ? service_type[s_index].delivery_service_id : 0"
                                                ></ntaps-senders-filter>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col cols="6" v-if="service_type[s_index] && service_type[s_index].available_addons.length > 0">
                                        <label>Tilläggstjänster</label>
                                        <b-row>
                                            <b-col
                                                cols="6"
                                                v-for="(addon, addon_index) in service_type[s_index].available_addons"
                                                :key="'st-addon-' + addon_index"
                                            >
                                                <div class="custom-control custom-checkbox mb-2">
                                                    <input
                                                        type="checkbox"
                                                        class="custom-control-input"
                                                        :id="'st-add-' + addon.name"
                                                        :checked="selected_service_addons[s_index][addon.name]"
                                                        @input="setAddon(s_index, addon.name, $event)"
                                                        :disabled="addon.include_by_default"
                                                    >
                                                    <label class="custom-control-label" :for="'st-add-' + addon.name">{{ (addon.ui_json && addon.ui_json.name ? addon.ui_json.name : addon.name) }}</label>
                                                </div>
                                                <div v-if="print_job.shipments[s_index].service_addons[addon.name]">
                                                    <div v-for="(attribute, attribute_index) in addon.items" :key="'st-addon-attr-' + addon_index + '-' + attribute_index ">
                                                        <input
                                                            type="text"
                                                            :placeholder="attribute.name"
                                                            v-model="print_job.shipments[s_index].service_addons[addon.name].items[attribute.name]"
                                                            class="form-control"
                                                        >
                                                    </div>
                                                </div>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-row>
                            </b-card-body>
                        </template>
    <!--                    <b-card-header header-bg-variant="light" class="border-top py-2">-->
    <!--                        <b-card-title title-tag="h5">Avsändare</b-card-title>-->
    <!--                    </b-card-header>-->
    <!--                    <b-card-body>-->
    <!--                        <b-row>-->
    <!--                            <b-col cols="6">-->
    <!--                                <b-form-group label="Avsändare">-->
    <!--                                    <input-with-validation-->
    <!--                                        :vid="'shipments.' + s_index + '.sender.address.name'"-->
    <!--                                        v-model="print_job.shipments[s_index].sender.address.name"-->
    <!--                                        label="Namn"-->
    <!--                                        hide-label-->
    <!--                                        class="mb-1"-->
    <!--                                        :disabled="busy_printing"-->
    <!--                                    />-->
    <!--                                    <input-with-validation-->
    <!--                                        :vid="'shipments.' + s_index + '.sender.address.care_of'"-->
    <!--                                        v-model="print_job.shipments[s_index].sender.address.care_of"-->
    <!--                                        label="C/O"-->
    <!--                                        hide-label-->
    <!--                                        class="mb-1"-->
    <!--                                        :disabled="busy_printing"-->
    <!--                                    />-->
    <!--                                    <input-with-validation-->
    <!--                                        v-for="(line, l_index) in print_job.shipments[s_index].sender.address.address_lines"-->
    <!--                                        :key="'r_al-' + l_index"-->
    <!--                                        :vid="'shipments.' + s_index + '.sender.address.address_lines.' + l_index"-->
    <!--                                        v-model="print_job.shipments[s_index].sender.address.address_lines[l_index]"-->
    <!--                                        :label="'Adressrad ' + (l_index + 1)"-->
    <!--                                        hide-label-->
    <!--                                        class="mb-1"-->
    <!--                                        :disabled="busy_printing"-->
    <!--                                    />-->
    <!--                                    <b-row class="mb-1">-->
    <!--                                        <b-col cols="4">-->
    <!--                                            <input-with-validation-->
    <!--                                                :vid="'shipments.' + s_index + '.sender.address.postal_code'"-->
    <!--                                                v-model="print_job.shipments[s_index].sender.address.postal_code"-->
    <!--                                                label="Postnummer"-->
    <!--                                                hide-label-->
    <!--                                                :disabled="busy_printing"-->
    <!--                                            />-->
    <!--                                        </b-col>-->
    <!--                                        <b-col cols="8">-->
    <!--                                            <input-with-validation-->
    <!--                                                :vid="'shipments.' + s_index + '.sender.address.city'"-->
    <!--                                                v-model="print_job.shipments[s_index].sender.address.city"-->
    <!--                                                label="Stad"-->
    <!--                                                hide-label-->
    <!--                                                :disabled="busy_printing"-->
    <!--                                            />-->
    <!--                                        </b-col>-->
    <!--                                    </b-row>-->
    <!--                                    <b-row class="mb-3">-->
    <!--                                        <b-col cols="4">-->
    <!--                                            <b-form-group>-->
    <!--                                                <country-filter-->
    <!--                                                    :vid="'shipments.' + s_index + '.sender.address.country'"-->
    <!--                                                    :reduce="opt => opt.id"-->
    <!--                                                    v-model="print_job.shipments[s_index].sender.address.country"-->
    <!--                                                    placeholder="&#45;&#45; Välj land &#45;&#45;"-->
    <!--                                                    :disabled="busy_printing"-->
    <!--                                                />-->
    <!--                                            </b-form-group>-->
    <!--                                        </b-col>-->
    <!--                                    </b-row>-->
    <!--                                    <b-row>-->
    <!--                                        <b-col cols="4">-->
    <!--                                            <input-with-validation-->
    <!--                                                :vid="'shipments.' + s_index + '.sender.address.door_code'"-->
    <!--                                                v-model="print_job.shipments[s_index].sender.address.door_code"-->
    <!--                                                label="Portkod"-->
    <!--                                                :disabled="busy_printing"-->
    <!--                                            />-->
    <!--                                        </b-col>-->
    <!--                                    </b-row>-->
    <!--                                </b-form-group>-->
    <!--                            </b-col>-->
    <!--                            <b-col cols="6">-->
    <!--                                <input-with-validation-->
    <!--                                    :vid="'shipments.' + s_index + '.sender.contact'"-->
    <!--                                    v-model="print_job.shipments[s_index].sender.contact"-->
    <!--                                    label="Kontakt"-->
    <!--                                    :disabled="busy_printing"-->
    <!--                                />-->

    <!--                                <input-with-validation-->
    <!--                                    :vid="'shipments.' + s_index + '.sender.email'"-->
    <!--                                    v-model="print_job.shipments[s_index].sender.email"-->
    <!--                                    label="E-postadress"-->
    <!--                                    :disabled="busy_printing"-->
    <!--                                />-->

    <!--                                <input-with-validation-->
    <!--                                    :vid="'shipments.' + s_index + '.sender.phone'"-->
    <!--                                    v-model="print_job.shipments[s_index].sender.phone"-->
    <!--                                    label="Telefon"-->
    <!--                                    :disabled="busy_printing"-->
    <!--                                />-->
    <!--                            </b-col>-->
    <!--                        </b-row>-->
    <!--                    </b-card-body>-->
                        <b-card-header header-bg-variant="light" class="border-top py-2">
                            <b-card-title title-tag="h5">Mottagare</b-card-title>
                        </b-card-header>
                        <b-card-body>
                            <b-row>
                                <b-col cols="6">
                                    <b-form-group label="Mottagare">
                                        <input-with-validation
                                            :vid="'shipments.' + s_index + '.receiver.address.name'"
                                            v-model="print_job.shipments[s_index].receiver.address.name"
                                            label="Namn"
                                            hide-label
                                            class="mb-1"
                                            :disabled="busy_printing"
                                            :rules="{ required: true, max: (print_job.shipments[s_index].service_type && print_job.shipments[s_index].service_type.startsWith('UPS') ? 35 : 200) }"
                                        />
                                        <input-with-validation
                                            :vid="'shipments.' + s_index + '.receiver.address.care_of'"
                                            v-model="print_job.shipments[s_index].receiver.address.care_of"
                                            label="C/O"
                                            hide-label
                                            class="mb-1"
                                            :disabled="busy_printing"
                                            :rules="{ max: (print_job.shipments[s_index].service_type && print_job.shipments[s_index].service_type.startsWith('UPS') ? 35 : 200) }"
                                        />
                                        <input-with-validation
                                            v-for="(line, l_index) in print_job.shipments[s_index].receiver.address.address_lines"
                                            :key="'r_al-' + l_index"
                                            :vid="'shipments.' + s_index + '.receiver.address.address_lines.' + l_index"
                                            v-model="print_job.shipments[s_index].receiver.address.address_lines[l_index]"
                                            :label="'Adressrad ' + (l_index + 1)"
                                            hide-label
                                            class="mb-1"
                                            :disabled="busy_printing"
                                            :rules="{ max: (print_job.shipments[s_index].service_type && print_job.shipments[s_index].service_type.startsWith('UPS') ? 35 : 200) }"
                                        />
                                        <b-row class="mb-1">
                                            <b-col cols="4">
                                                <input-with-validation
                                                    :vid="'shipments.' + s_index + '.receiver.address.postal_code'"
                                                    v-model="print_job.shipments[s_index].receiver.address.postal_code"
                                                    label="Postnummer"
                                                    hide-label
                                                    :disabled="busy_printing"
                                                    :rules="{ required: true, max: (print_job.shipments[s_index].service_type && print_job.shipments[s_index].service_type.startsWith('UPS') ? 35 : 200) }"
                                                />
                                            </b-col>
                                            <b-col cols="8">
                                                <input-with-validation
                                                    :vid="'shipments.' + s_index + '.receiver.address.city'"
                                                    v-model="print_job.shipments[s_index].receiver.address.city"
                                                    label="Stad"
                                                    hide-label
                                                    :disabled="busy_printing"
                                                    :rules="{ required: true, max: (print_job.shipments[s_index].service_type && print_job.shipments[s_index].service_type.startsWith('UPS') ? 35 : 200) }"
                                                />
                                            </b-col>
                                        </b-row>
                                        <b-row class="mb-3">
                                            <b-col cols="4">
                                                <ValidationProvider
                                                    :vid="'shipments.' + s_index + '.receiver.address.country'"
                                                    v-slot="{ errors }"
                                                    tag="div"
                                                    rules="required"
                                                    name="Land"
                                                >
                                                    <b-form-group
                                                        :invalid-feedback="errors[0]"
                                                        :state="!errors.length"
                                                    >
                                                        <country-filter
                                                            :vid="'shipments.' + s_index + '.receiver.address.country'"
                                                            v-model="print_job.shipments[s_index].receiver.address.country"
                                                            placeholder="-- Välj land --"
                                                            :reduce="opt => opt.id"
                                                            :disabled="busy_printing"
                                                            rules="required"
                                                            :class="{ 'has-validation-error': (errors.length > 0) }"
                                                        />
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col cols="4">
                                                <b-form-group>
                                                    <input-with-validation
                                                        :vid="'shipments.' + s_index + '.receiver.address.region'"
                                                        v-model="print_job.shipments[s_index].receiver.address.region"
                                                        label="Region/Stat"
                                                        hide-label
                                                        :disabled="busy_printing"
                                                        :rules="{ max: (print_job.shipments[s_index].service_type && print_job.shipments[s_index].service_type.startsWith('UPS') ? 35 : 200) }"
                                                    />
                                                </b-form-group>
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col cols="4">
                                                <input-with-validation
                                                    :vid="'shipments.' + s_index + '.receiver.address.door_code'"
                                                    v-model="print_job.shipments[s_index].receiver.address.door_code"
                                                    label="Portkod"
                                                    :disabled="busy_printing"
                                                />
                                            </b-col>
                                        </b-row>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="6">
                                    <input-with-validation
                                        :vid="'shipments.' + s_index + '.receiver.contact'"
                                        v-model="print_job.shipments[s_index].receiver.contact"
                                        label="Kontakt"
                                        :disabled="busy_printing"
                                    />
                                    <input-with-validation
                                        :vid="'shipments.' + s_index + '.receiver.email'"
                                        v-model="print_job.shipments[s_index].receiver.email"
                                        label="E-postadress"
                                        :disabled="busy_printing"
                                    />
                                    <input-with-validation
                                        :vid="'shipments.' + s_index + '.receiver.phone'"
                                        v-model="print_job.shipments[s_index].receiver.phone"
                                        label="Telefon"
                                        :disabled="busy_printing"
                                    />
                                </b-col>
                            </b-row>
                        </b-card-body>
                        <b-card-header header-bg-variant="light" class="border-top py-2">
                            <b-card-title title-tag="h5">Sändningsinformation</b-card-title>
                        </b-card-header>
                        <b-card-body>
                            <b-row>
                                <b-col cols="8">
                                    <b-row>
                                        <b-col cols="4">
                                            <input-with-validation
                                                :vid="'shipments.' + s_index + '.reference'"
                                                v-model="print_job.shipments[s_index].reference"
                                                label="Referens"
                                                class="mb-1"
                                                :disabled="busy_printing"
                                            />
                                        </b-col>
                                        <b-col cols="8">
                                            <textarea-with-validation
                                                v-model="print_job.shipments[s_index].delivery_instructions"
                                                label="Transportinstruktion"
                                                class="mb-1"
                                                :disabled="busy_printing"
                                            />
                                        </b-col>
                                    </b-row>

                                    <b-card
                                        v-for="(parcel, p_index) in print_job.shipments[s_index].parcels"
                                        :key="'p-' + p_index"
                                        no-body
                                    >
                                        <b-card-header header-bg-variant="light" class="py-2 header-elements-inline">
                                            <b-card-title title-tag="h5">Kolli {{ p_index + 1 }}</b-card-title>
                                            <div class="header-elements" v-if="print_job.shipments[s_index].parcels.length > 1">
                                                <b-button
                                                    @click="deleteParcel(s_index, p_index)"
                                                    size="sm"
                                                    variant="danger"
                                                    :disabled="busy_printing"
                                                >
                                                    <i class="icon-trash mr-1"></i>Radera
                                                </b-button>
                                            </div>
                                        </b-card-header>
                                        <b-card-body>
                                            <b-row>
                                                <b-col cols="3">
                                                    <input-with-validation
                                                        v-model="print_job.shipments[s_index].parcels[p_index].parcel_contents"
                                                        label="Innehåll"
                                                        :disabled="busy_printing"
                                                    />
                                                </b-col>
                                                <b-col cols="3">
                                                    <input-with-validation
                                                        v-model="print_job.shipments[s_index].parcels[p_index].weight"
                                                        label="Vikt (g)"
                                                        :disabled="busy_printing"
                                                        rules="integer"
                                                    />
                                                </b-col>
                                                <b-col cols="3">
                                                    <input-with-validation
                                                        v-model="print_job.shipments[s_index].parcels[p_index].volume"
                                                        label="Volym (m³)"
                                                        disabled
                                                    />
                                                </b-col>
                                                <b-col cols="3">
                                                    <label>Paketkod</label>
                                                    <v-select
                                                        :options="service_type[s_index] ? service_type[s_index].package_codes : []"
                                                        v-model="print_job.shipments[s_index].parcels[p_index].package_code"
                                                        :reduce="(opt) => opt.package_code.name"
                                                        :getOptionLabel="(opt) => ((opt.package_code && opt.package_code.ui_json && opt.package_code.ui_json.name) ? opt.package_code.ui_json.name : opt.id)"
                                                        @input="setPackageCode(s_index, p_index, $event)"
                                                        :clearable="false"
                                                    ></v-select>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col cols="3">
                                                    <label>Storlek</label>
                                                    <v-select
                                                        :key="'pzize-s-' + s_index + '-p-' + p_index"
                                                        placeholder="-- EGEN STORLEK --"
                                                        :options="parcel_sizes"
                                                        v-model="selected_parcel_size[s_index][p_index]"
                                                        @option:selected="setParcelSize(s_index, p_index)"
                                                        @option:deselected="setParcelSize(s_index, p_index)"
                                                    ></v-select>
                                                </b-col>
                                                <b-col cols="3">
                                                    <input-with-validation
                                                        v-model="print_job.shipments[s_index].parcels[p_index].dimensions.length"
                                                        label="Längd (cm)"
                                                        @input="calcParcelVolume(s_index, p_index, true)"
                                                        :disabled="busy_printing"
                                                        rules="integer"
                                                    />
                                                </b-col>
                                                <b-col cols="3">
                                                    <input-with-validation
                                                        v-model="print_job.shipments[s_index].parcels[p_index].dimensions.width"
                                                        label="Bredd (cm)"
                                                        @input="calcParcelVolume(s_index, p_index, true)"
                                                        :disabled="busy_printing"
                                                        rules="integer"
                                                    />
                                                </b-col>
                                                <b-col cols="3">
                                                    <input-with-validation
                                                        v-model="print_job.shipments[s_index].parcels[p_index].dimensions.height"
                                                        label="Höjd (cm)"
                                                        @input="calcParcelVolume(s_index, p_index, true)"
                                                        :disabled="busy_printing"
                                                        rules="integer"
                                                    />
                                                </b-col>
                                            </b-row>
                                        </b-card-body>
                                    </b-card>
                                    <b-button
                                        variant="light"
                                        @click="addParcel(s_index)"
                                        block
                                        :disabled="busy_printing"
                                    >
                                        <i class="icon-plus3 mr-1"></i>Lägg till kolli
                                    </b-button>
                                </b-col>
                                <b-col cols="4">
                                    <b-card no-body>
                                        <b-card-header header-bg-variant="light" class="py-2">
                                            <b-card-title title-tag="h5">Varor</b-card-title>
                                        </b-card-header>
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th>SKU</th>
                                                    <th>Produkt</th>
                                                    <th class="text-right">Antal</th>
                                                    <th style="width: 50px;"></th>
                                                </tr>
                                            </thead>
                                            <tbody v-if="Array.isArray(print_job.shipments[s_index].contents.goods) && print_job.shipments[s_index].contents.goods.length > 0">
                                                <tr v-for="(goods, g_index) in print_job.shipments[s_index].contents.goods" :key="'g-' + g_index">
                                                    <td>{{ goods.sku }}</td>
                                                    <td>
                                                        <div>{{ goods.name }}</div>
                                                        <div class="text-muted">
                                                            <div v-if="goods.hs_tariff_number">HS: {{ goods.hs_tariff_number }}<span v-if="goods.country_of_origin"> ({{ goods.country_of_origin }})</span></div>
                                                            <div v-else>HS: <span class="badge badge-danger">TULLINFORMATION SAKNAS</span></div>
                                                            <div>Vikt: <span :class="{'badge': !goods.unit_gross_weight, 'badge-danger': !goods.unit_gross_weight}">{{ (goods.unit_gross_weight?goods.unit_gross_weight:'SAKNAS') }}</span> g</div>
                                                            <div v-if="goods.dimensions && (goods.dimensions.height || goods.dimensions.length || goods.dimensions.width)">
                                                                <span v-if="goods.dimensions.length" class="mr-1">Längd: {{ goods.dimensions.length }} cm</span>
                                                                <span v-if="goods.dimensions.width" class="mr-1">Bredd: {{ goods.dimensions.width }} cm</span>
                                                                <span v-if="goods.dimensions.height" class="mr-1">Höjd: {{ goods.dimensions.height }} cm</span>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td class="text-right">{{ goods.quantity }}</td>
                                                    <td class="text-right" style="width: 50px;">
                                                        <b-button variant="danger" @click="removeGoods(s_index, g_index)" class="btn-sm">
                                                            <i class="icon-trash"></i>
                                                        </b-button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tbody v-else>
                                                <tr>
                                                    <td colspan="4">
                                                        <i>Inga varor...</i>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <b-card-body class="p-2">
                                            <b-button
                                                variant="light"
                                                @click="showModalAddGoods(s_index)"
                                                block
                                                :disabled="busy_printing"
                                            >
                                                <i class="icon-plus3 mr-1"></i>Lägg till vara
                                            </b-button>
                                        </b-card-body>
                                    </b-card>
                                </b-col>
                            </b-row>
                        </b-card-body>
                        <b-card-header header-bg-variant="light" class="border-top py-2">
                            <b-card-title title-tag="h5">Tulldeklaration</b-card-title>
                        </b-card-header>
                        <b-card-body>
                            <div v-if="print_job.shipments[s_index].customs">
                                <b-row>
                                    <b-col>
                                        <input-with-validation
                                            v-model="print_job.shipments[s_index].customs.declaration.general_customs_declaration.contents_explanation"
                                            label="Innehåll"
                                            :disabled="busy_printing"
                                            rules="required"
                                        />
                                        <b-row>
                                            <b-col cols="6">
                                                <ValidationProvider vid="contents_type" name="Typ" rules="required" v-slot="{ errors }">
                                                    <b-form-group
                                                        :invalid-feedback="errors[0]"
                                                        :state="!errors.length"
                                                        label="Typ"
                                                    >
                                                        <v-select
                                                            placeholder="-- Välj Typ --"
                                                            :options="contents_types"
                                                            v-model="print_job.shipments[s_index].customs.declaration.general_customs_declaration.contents_type"
                                                            :disabled="busy_printing"
                                                        />
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col cols="6">
                                                <ValidationProvider vid="in_co_terms" name="Incoterms" rules="required" v-slot="{ errors }">
                                                    <b-form-group
                                                        :invalid-feedback="errors[0]"
                                                        :state="!errors.length"
                                                        label="Incoterms"
                                                    >
                                                        <v-select
                                                            placeholder="-- Välj Incoterms --"
                                                            :options="in_co_terms"
                                                            v-model="print_job.shipments[s_index].customs.declaration.general_customs_declaration.in_co_terms"
                                                            :disabled="busy_printing"
                                                            :reduce="(opt) => opt.id"
                                                        />
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col cols="6">
                                                <ValidationProvider vid="invoice_date" name="Fakturadatum" v-slot="{ errors }">
                                                    <b-form-group
                                                        :invalid-feedback="errors[0]"
                                                        :state="!errors.length"
                                                        label="Fakturadatum"
                                                    >
                                                        <v-date-picker
                                                            v-model="print_job.shipments[s_index].customs.declaration.general_customs_declaration.invoice_date"
                                                            mode="date"
                                                            :model-config="{ type: 'string', mask: 'YYYY-MM-DD' }"
                                                            :masks="{ input: 'YYYY-MM-DD' }"
                                                        >
                                                            <template v-slot="{ inputValue, togglePopover }">
                                                                <div class="input-group">
                                                                    <input class="form-control" :value="inputValue" @focus="togglePopover()">
                                                                    <span class="input-group-append">
                                                                <button
                                                                    class="btn btn-light"
                                                                    type="button" @click="print_job.shipments[s_index].customs.declaration.general_customs_declaration.invoice_date = ''"
                                                                >
                                                                    <i class="icon-cross3"></i>
                                                                </button>
                                                            </span>
                                                                </div>
                                                            </template>
                                                        </v-date-picker>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col cols="6">
                                                <input-with-validation
                                                    v-model="print_job.shipments[s_index].customs.declaration.general_customs_declaration.invoice_number"
                                                    label="Fakturanummer"
                                                    :disabled="busy_printing"
                                                />
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-row>
                            </div>
                            <div v-else>
                                <b-button variant="light" @click="createCustomsDeclaration(s_index)">Skapa tulldeklaration</b-button>
                            </div>
                        </b-card-body>
                    </b-card>

                    <div class="row">
                        <div class="col-lg-3 d-flex">
                            <div class="col-form-label pr-1">Skrivare:</div>
                            <div class="flex-grow-1">
                                <ValidationProvider
                                    vid="printer_tag"
                                    v-slot="{ errors }"
                                    tag="div"
                                    rules="required"
                                    class="flex-grow-1"
                                    name="Skrivare"
                                >
                                    <label-printer-filter
                                        :class="{'has-validation-error': !!(errors[0]) }"
                                        v-model="print_job.printer_tag"
                                        :reduce="opt => opt.tag"
                                        placeholder="-- Välj skrivare --"
                                        :disabled="busy_printing"
                                    />
                                    <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                </ValidationProvider>
                                <div class="custom-control custom-checkbox mt-3">
                                    <input type="checkbox" class="custom-control-input" id="chk-default-printer" v-model="set_as_defualt_printer">
                                    <label class="custom-control-label" for="chk-default-printer">Sätt vald skrivare som standardskrivare på denna dator</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <limitless-button
                                type="submit"
                                saved-text="Skickat till skrivaren!"
                                :busy="busy_printing"
                                ref="btnprintlabel"
                            >
                                Skriv ut fraktsedel
                            </limitless-button>
                        </div>
                    </div>
                </ValidationObserver>
            </form>

            <b-modal id="modal-add-goods" title="Lägg till vara" @ok="addGoods">
                <form @submit.prevent="ok()">
                    <ValidationObserver ref="addgoodsform">
                        <div class="row">
                            <div class="col-8">
                                <ValidationProvider vid="sku" name="Vara" rules="required" v-slot="{ errors }">
                                    <div class="form-group">
                                        <label>Vara</label>
                                        <product-filter
                                            :reduce="(opt) => opt.ProdID"
                                            v-model="goods_to_add.sku"
                                            placeholder="Välj vara..."
                                            @option:selected="setAddGoodsSku"
                                        ></product-filter>
                                        <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div class="col-4">
                                <ValidationProvider vid="quantity" name="Antal" rules="required" v-slot="{ errors }">
                                    <div class="form-group">
                                        <label>Antal</label>
                                        <input type="number" step="1" min="1" class="form-control" v-model="goods_to_add.quantity" :class="{ 'border-danger':errors[0] }">
                                        <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <ValidationProvider vid="name" name="Benämning" rules="required" v-slot="{ errors }">
                                    <div class="form-group">
                                        <label>Benämning</label>
                                        <input type="text" class="form-control" v-model="goods_to_add.name" :class="{ 'border-danger':errors[0] }">
                                        <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div class="col-6">
                                <ValidationProvider vid="brand" name="Varumärke" rules="required" v-slot="{ errors }">
                                    <div class="form-group">
                                        <label>Varumärke</label>
                                        <input type="text" class="form-control" v-model="goods_to_add.brand" :class="{ 'border-danger':errors[0] }">
                                        <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-3">
                                <ValidationProvider vid="dimensions.length" name="Längd" rules="required" v-slot="{ errors }">
                                    <div class="form-group">
                                        <label>Längd (cm)</label>
                                        <input type="text" min="0" step="1" class="form-control" v-model="goods_to_add.dimensions.length" :class="{ 'border-danger':errors[0] }">
                                        <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div class="col-3">
                                <ValidationProvider vid="dimensions.width" name="Bredd" rules="required" v-slot="{ errors }">
                                    <div class="form-group">
                                        <label>Bredd (cm)</label>
                                        <input type="text" min="0" step="1" class="form-control" v-model="goods_to_add.dimensions.width" :class="{ 'border-danger':errors[0] }">
                                        <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div class="col-3">
                                <ValidationProvider vid="dimensions.height" name="Höjd" rules="required" v-slot="{ errors }">
                                    <div class="form-group">
                                        <label>Höjd (cm)</label>
                                        <input type="text" min="0" step="1" class="form-control" v-model="goods_to_add.dimensions.height" :class="{ 'border-danger':errors[0] }">
                                        <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div class="col-3">
                                <ValidationProvider vid="unit_gross_weight" name="Vikt" rules="required" v-slot="{ errors }">
                                    <div class="form-group">
                                        <label>Vikt (g)</label>
                                        <input type="text" class="form-control" v-model="goods_to_add.unit_gross_weight" :class="{ 'border-danger':errors[0] }">
                                        <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <ValidationProvider vid="country_of_origin" name="Ursprungsland" rules="required" v-slot="{ errors }">
                                    <div class="form-group">
                                        <label>Ursprungsland</label>
                                        <country-filter
                                            :reduce="(opt) => opt.id"
                                            v-model="goods_to_add.country_of_origin"
                                            placeholder="Välj ursprungsland..."
                                        ></country-filter>
                                        <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div class="col-6">
                                <ValidationProvider vid="hs_tariff_number" name="Tulltariffkod" :rules="{ required: true, length: 8 }" v-slot="{ errors }">
                                    <div class="form-group">
                                        <label>Tulltariffkod</label>
                                        <input type="text" class="form-control" v-model="goods_to_add.hs_tariff_number" :class="{ 'border-danger': errors[0] }">
                                        <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <ValidationProvider vid="unit_value" name="Värde" rules="required" v-slot="{ errors }">
                                    <div class="form-group">
                                        <label>Värde per styck (SEK)</label>
                                        <input type="text" min="0" step="0.01" class="form-control" v-model="goods_to_add.unit_value" :class="{ 'border-danger':errors[0] }">
                                        <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>
                            </div>
                        </div>
                    </ValidationObserver>
                </form>
                <template #modal-footer="{ ok, cancel }">
                    <button type="button" class="btn btn-light" @click="cancel()">Avbryt</button>
                    <limitless-button ref="btnaddgoods" type="button" @click="ok()" icon="icon-plus3">LÄGG TILL</limitless-button>
                </template>
            </b-modal>
        </div>
    </div>
</template>

<script>
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import LimitlessPageHeaderButton from '@components/Layout/partials/LimitlessPageHeaderButton';
import vSelect from 'vue-select';
import InputWithValidation from '@components/Form/InputWithValidation';
import CountryFilter from '@components/Filters/CountryFilter';
import LabelPrinterFilter from '@components/Filters/LabelPrinterFilter';
import TextareaWithValidation from '@components/Form/TextareaWithValidation';
import apiClient from '@services/ApiClient';
import getError from '@services/ErrorHelper';
import LimitlessButton from '@components/Limitless/LimitlessButton';
import VDatePicker from 'v-calendar/lib/components/date-picker.umd';
import NtapsServiceTypesRepository from '@services/repositories/NtapsServiceTypesRepository';
import Cookies from 'js-cookie';
import ProductFilter from '@components/Filters/ProductFilter.vue';
import ProductRepository from '@services/repositories/Product/ProductRepository';
import NtapsSendersFilter from '@components/Filters/NtapsSendersFilter.vue';
import { hasRole } from '@services/Helpers';

export default {
    name: 'NtapsPrintLabel',
    components: {
        LimitlessPageHeader,
        LimitlessPageHeaderButton,
        NtapsSendersFilter,
        ProductFilter,
        LimitlessButton,
        VDatePicker,
        LabelPrinterFilter,
        CountryFilter,
        InputWithValidation,
        TextareaWithValidation,
        vSelect,
    },
    data: () => ({
        set_as_defualt_printer: false,
        shipment: null,
        prod_order_id: null,
        return_order_id: null,
        card_order_id: null,
        delivery_address_id: null,
        busy_printing: false,
        freightlabel_printers: [],
        receiver: null,
        services: [],
        service_type: {},
        selected_service_addons: {},
        selected_parcel_size: {},
        parcel_sizes: [
            {
                id: 1,
                label: 'Paket: 40x30x20',
                tag: 'PARCEL_40x30',
                length: 40,
                width: 30,
                height: 20,
                weight: 0,
            },
            {
                id: 2,
                label: 'EUR-Pall: 80x120',
                tag: 'PALLET_80x120',
                length: 120,
                width: 80,
                height: 150,
                weight: 25000,
            },
            {
                id: 3,
                label: 'Bur: 80x120',
                tag: 'CAGE_80x120',
                length: 120,
                width: 80,
                height: 170,
                weight: 25000,
            },
            {
                id: 4,
                label: 'Möbelpall: 120x240',
                tag: 'PALLET_120x240',
                length: 240,
                width: 120,
                height: 123,
                weight: 35000,
            },
            {
                id: 5,
                label: 'Möbelpall: 120x120',
                tag: 'PALLET_120x120',
                length: 120,
                width: 120,
                height: 150,
                weight: 35000,
            },
            {
                id: 6,
                label: 'Möbelpall: 80x160',
                tag: 'PALLET_80x160',
                length: 160,
                width: 80,
                height: 150,
                weight: 35000,
            },
            {
                id: 7,
                label: 'Kvarts-Pall: 40x60',
                tag: 'PALLET_40x60',
                length: 40,
                width: 60,
                height: 150,
                weight: 15000,
            },
            {
                id: 8,
                label: 'Halv-Pall: 80x60',
                tag: 'PALLET_80x60',
                length: 80,
                width: 60,
                height: 150,
                weight: 20000,
            },
        ],
        contents_types: [
            { id: 'UNKNOWN', label: 'UNKNOWN' },
            { id: 'DOCUMENTS', label: 'DOCUMENTS' },
            { id: 'GIFT', label: 'GIFT' },
            { id: 'COMMERCIAL_SAMPLE', label: 'COMMERCIAL_SAMPLE' },
            { id: 'SALE', label: 'SALE' },
            { id: 'RETURN', label: 'RETURN' },
            { id: 'OTHER', label: 'OTHER' },
        ],
        in_co_terms: [
            { id: 'INCOTERMS_UNKNOWN', label: 'INCOTERMS_UNKNOWN' },
            { id: 'EXW', label: 'EXW' },
            { id: 'FCA', label: 'FCA' },
            { id: 'FAS', label: 'FAS' },
            { id: 'FOB', label: 'FOB' },
            { id: 'CFR', label: 'CFR' },
            { id: 'CIF', label: 'CIF' },
            { id: 'CPT', label: 'CPT' },
            { id: 'CIP', label: 'CIP' },
            { id: 'DAT', label: 'DAT' },
            { id: 'DAP', label: 'DAP' },
            { id: 'DDP', label: 'DDP' },
            { id: 'DAF', label: 'DAF' },
            { id: 'DDU', label: 'DDU' },
            { id: 'DEQ', label: 'DEQ' },
            { id: 'DES', label: 'DES' },
            { id: 'DPU', label: 'DPU' },
        ],
        print_job: {
            test_mode: false,
            printer_tag: null,
            shipments: [{
                sender_tag: null,
                service_type: null,
                reference: '',
                service_addons: [],
                contents: {
                    goods: [],
                },
                internal_data: {
                    display_product_rows: false,
                },
                // sender: {
                //     sender_id: null,
                //     phone: '',
                //     email: '',
                //     contact: '',
                //     address: {
                //         name: '',
                //         care_of: '',
                //         address_lines: [
                //             '',
                //         ],
                //         city: '',
                //         postal_code: '',
                //         country: '',
                //         door_code: '',
                //         attn: '',
                //         apartment_number: '',
                //     },
                // },
                receiver: {
                    email: '',
                    phone: '',
                    contact: '',
                    address: {
                        name: '',
                        care_of: '',
                        address_lines: [
                            '',
                        ],
                        city: '',
                        postal_code: '',
                        country: '',
                        region: '',
                        door_code: '',
                        attn: '',
                        apartment_number: '',
                    },
                },
                parcels: [],
                delivery_instructions: '',
                delivery_party: null,
                customs: null,
            }],
        },
        goods_to_add_shipments_index: 0,
        goods_to_add: {
            quantity: 1,
            sku: null,
            name: '',
            dimensions: {
                width: 100,
                height: 100,
                length: 100,
            },
            unit_gross_weight: '',
            brand: '',
            category: '',
            country_of_origin: null,
            hs_tariff_number: '',
            unit_value: '',
            currency: 'SEK',
        },
    }),
    async mounted() {
        await this.getShippingServices();
        const printerTag = Cookies.get('freightlabel_printer');
        if (printerTag) {
            this.print_job.printer_tag = printerTag;
        }
        await this.fillShipment();
    },
    methods: {
        hasRole,
        setPackageCode(shipmentIndex, parcelIndex, packageCode, isReprint) {
            if (!isReprint) {
                this.print_job.shipments[shipmentIndex].parcels[parcelIndex].package_code = packageCode;
            }
            if (!this.print_job.shipments[shipmentIndex].parcels[parcelIndex].package_code) {
                const defaultCode = this.service_type[shipmentIndex]?.package_codes?.find((item) => item.is_default)?.package_code;
                if (defaultCode) {
                    this.print_job.shipments[shipmentIndex].parcels[parcelIndex].package_code = defaultCode.name;
                }
            }

            const currentPackageCode = this.service_type[shipmentIndex]?.package_codes?.find((pc) => pc.package_code.name === this.print_job.shipments[shipmentIndex].parcels[parcelIndex].package_code);
            if (currentPackageCode) {
                const defaultPackageTag = currentPackageCode?.package_code?.ui_json?.default_package_tag;
                const defaultParcelSize = this.parcel_sizes.find((parcel) => parcel.tag === defaultPackageTag);
                if (defaultParcelSize) {
                    this.setParcelSize(shipmentIndex, parcelIndex, defaultParcelSize, isReprint);
                }
            }
        },
        setParcelSize(shipmentIndex, parcelIndex, parcelSize = null, isReprint) {
            if (parcelSize?.tag) {
                if (!this.selected_parcel_size[shipmentIndex]) {
                    this.selected_parcel_size[shipmentIndex] = {};
                }
                if (!isReprint) {
                    this.selected_parcel_size[shipmentIndex][parcelIndex] = parcelSize;
                }
            }

            const isCage = this.selected_parcel_size[shipmentIndex][parcelIndex]?.tag === 'CAGE_80x120';
            const hasCageRentAddon = this.selected_service_addons[shipmentIndex]?.NP_CAGERENT;

            if (this.selected_parcel_size[shipmentIndex][parcelIndex]) {
                if (!isReprint) {
                    this.print_job.shipments[shipmentIndex].parcels[parcelIndex].dimensions.length = this.selected_parcel_size[shipmentIndex][parcelIndex].length;
                    this.print_job.shipments[shipmentIndex].parcels[parcelIndex].dimensions.width = this.selected_parcel_size[shipmentIndex][parcelIndex].width;
                    this.print_job.shipments[shipmentIndex].parcels[parcelIndex].dimensions.height = this.selected_parcel_size[shipmentIndex][parcelIndex].height;
                }
                this.calcParcelVolume(shipmentIndex, parcelIndex);
            }

            if (isCage && !hasCageRentAddon) {
                const cageRent = this.service_type[shipmentIndex].available_addons.find((a) => a.name === 'NP_CAGERENT');

                if (cageRent) {
                    this.$nextTick(() => {
                        this.$swal({
                            text: 'Vill du LÄGGA TILL tilläggstjänsten BEHÅLLARHYRA?',
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonText: 'Ja, lägg till',
                        }).then((result) => {
                            if (result.isConfirmed) {
                                this.setAddon(shipmentIndex, 'NP_CAGERENT', true);
                            }
                        });
                    });
                }
            }

            if (!isCage && hasCageRentAddon) {
                this.$nextTick(() => {
                    this.$swal({
                        text: 'Vill du TA BORT tilläggstjänsten BEHÅLLARHYRA?',
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Ja, ta bort',
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.setAddon(shipmentIndex, 'NP_CAGERENT', false);
                        }
                    });
                });
            }
        },
        setServiceType(shipmentIndex, isReprint) {
            if (this.service_type[shipmentIndex]) {
                this.print_job.shipments[shipmentIndex].service_type = this.service_type[shipmentIndex].name;

                const selectedAddons = {};
                const shipmentAddons = [];
                this.service_type[shipmentIndex].available_addons.forEach((addon) => {
                    if (isReprint) {
                        if (this.print_job.shipments[shipmentIndex].service_addons.find((item) => item.name === addon.name)) {
                            selectedAddons[addon.name] = true;
                            shipmentAddons.push({
                                name: addon.name,
                            });
                            return;
                        }
                    }

                    selectedAddons[addon.name] = addon.include_by_default ?? false;
                    if (addon.include_by_default) {
                        shipmentAddons.push({
                            name: addon.name,
                        });
                    }
                });
                this.print_job.shipments[shipmentIndex].service_addons = shipmentAddons;
                this.selected_service_addons[shipmentIndex] = selectedAddons;
                if (this.print_job.shipments[shipmentIndex].parcels.length === 0) {
                    this.addParcel(shipmentIndex);
                }
                this.print_job.shipments[shipmentIndex].parcels.forEach((p, index) => {
                    this.setPackageCode(shipmentIndex, index, null, isReprint);
                });
            }
        },
        setAddon(shipmentIndex, addonName, checked) {
            if (checked instanceof Event) {
                // eslint-disable-next-line no-param-reassign
                checked = checked.target.checked;
            }
            if (!this.selected_service_addons[shipmentIndex]) {
                this.selected_service_addons[shipmentIndex] = {};
            }
            if (!this.selected_service_addons[shipmentIndex][addonName]) {
                this.selected_service_addons[shipmentIndex][addonName] = false;
            }
            this.selected_service_addons[shipmentIndex][addonName] = checked;
            if (checked) {
                const addon = this.print_job.shipments[shipmentIndex].service_addons.find((add) => add.name === addonName);
                if (!addon) {
                    this.print_job.shipments[shipmentIndex].service_addons.push({
                        name: addonName,
                    });
                }
            } else {
                const addonIndex = this.print_job.shipments[shipmentIndex].service_addons.findIndex((add) => add.name === addonName);
                if (addonIndex >= 0) {
                    this.print_job.shipments[shipmentIndex].service_addons.splice(addonIndex, 1);
                }
            }
        },
        calcParcelVolume(shipment, index, clearParcelSize) {
            if (clearParcelSize) {
                this.selected_parcel_size[shipment][index] = null;
            }

            if (
                this.print_job.shipments[shipment].parcels[index]
                && this.print_job.shipments[shipment].parcels[index].dimensions
                && this.print_job.shipments[shipment].parcels[index].dimensions.height
                && this.print_job.shipments[shipment].parcels[index].dimensions.length
                && this.print_job.shipments[shipment].parcels[index].dimensions.width
            ) {
                this.print_job.shipments[shipment].parcels[index].volume = (this.print_job.shipments[shipment].parcels[index].dimensions.height
                    * this.print_job.shipments[shipment].parcels[index].dimensions.length
                    * this.print_job.shipments[shipment].parcels[index].dimensions.width) / 1000000;
            }
        },
        deleteParcel(shipment, index) {
            if (this.print_job.shipments[shipment].parcels.length > 1) {
                this.print_job.shipments[shipment].parcels.splice(index, 1);
            }
            Object.keys(this.selected_parcel_size[shipment]).forEach((key) => {
                if (parseInt(key, 10) >= index) {
                    this.selected_parcel_size[shipment][key] = this.selected_parcel_size[shipment][parseInt(key, 10) + 1] ?? null;
                }
            });
            this.$delete(this.selected_parcel_size[shipment], this.print_job.shipments[shipment].parcels.length);
        },
        addParcel(shipmentIndex) {
            const index = this.print_job.shipments[shipmentIndex].parcels.length;
            this.print_job.shipments[shipmentIndex].parcels.push({
                parcel_qty: 1,
                parcel_contents: '',
                package_code: null,
                weight: 2000,
                volume: 24000,
                dimensions: {
                    height: this.parcel_sizes[0].height,
                    width: this.parcel_sizes[0].width,
                    length: this.parcel_sizes[0].length,
                },
            });
            if (!this.selected_parcel_size[shipmentIndex]) {
                this.selected_parcel_size[shipmentIndex] = {};
            }
            this.selected_parcel_size[shipmentIndex][index] = { ...this.parcel_sizes[0] };
            this.setPackageCode(shipmentIndex, index, null);
        },
        async printLabel() {
            const isValid = await this.$refs.printlabelform.validate();
            if (isValid) {
                if (this.set_as_defualt_printer) {
                    Cookies.set('freightlabel_printer', this.print_job.printer_tag, { expires: 365 });
                    this.set_as_defualt_printer = false;
                }
                this.busy_printing = true;
                await apiClient.post('/vue/shipping/ntaps/print', this.print_job)
                    .then(() => {
                        this.$refs.btnprintlabel.triggerSaved();
                    })
                    .catch((error) => {
                        const parsederror = getError(error);
                        if (typeof parsederror === 'object') {
                            this.$refs.printlabelform.setErrors(parsederror);
                        }
                        this.$refs.btnprintlabel.triggerFailed();
                    })
                    .finally(() => {
                        this.busy_printing = false;
                    });
            } else {
                this.$refs.btnprintlabel.triggerFailed();
            }
        },
        async fillShipment() {
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.has('prod_order_id')) {
                this.prod_order_id = urlParams.get('prod_order_id');
            }
            if (urlParams.has('return_order_id')) {
                this.return_order_id = urlParams.get('return_order_id');
            }
            if (urlParams.has('card_order_id')) {
                this.card_order_id = urlParams.get('card_order_id');
            }
            if (urlParams.has('delivery_address_id')) {
                this.delivery_address_id = urlParams.get('delivery_address_id');
            }
            let base64shipment = null;
            if (urlParams.has('shipment')) {
                base64shipment = urlParams.get('shipment');
            }

            await apiClient.post('/vue/shipping/ntaps/shipment', {
                prod_order_id: this.prod_order_id,
                return_order_id: this.return_order_id,
                card_order_id: this.card_order_id,
                delivery_address_id: this.delivery_address_id,
                shipment: base64shipment,
            }).then((res) => {
                if (res.data.shipment) {
                    this.shipment = res.data.shipment;
                }
            });

            if (this.shipment) {
                this.print_job.shipments[0] = this.nestedAssign(this.print_job.shipments[0], this.shipment);
                if (this.print_job.shipments[0].id) {
                    this.$delete(this.print_job.shipments[0], 'id');
                }
                if (this.shipment.service_type) {
                    const serviceType = this.service_types.find((st) => st.name === this.shipment.service_type);
                    if (serviceType) {
                        this.service_type[0] = serviceType;
                        this.setServiceType(0, this.shipment.internal_data?.is_reprint || false);
                    }
                }
            }

            // eslint-disable-next-line no-unused-vars
            this.print_job.shipments.forEach((shipment, sIndex) => {
                if (shipment.receiver.address.address_lines.length === 0) {
                    shipment.receiver.address.address_lines.push('');
                }
                if (shipment.receiver.address.address_lines.length === 1) {
                    shipment.receiver.address.address_lines.push('');
                }
                //     this.$set(this.selected_parcel_size, sIndex, {});
                //     shipment.parcels.forEach((parcel, pIndex) => {
                //         const size = this.parcel_sizes.find((s) => s.length === parcel.dimensions.length && s.width === parcel.dimensions.width && s.height === parcel.dimensions.height);
                //         if (size) {
                //             this.$set(this.selected_parcel_size[sIndex], pIndex, { ...size });
                //         } else {
                //             this.$set(this.selected_parcel_size[sIndex], pIndex, null);
                //         }
                //     });
            });
        },
        nestedAssign(target, source) {
            Object.keys(source).forEach((sourceKey) => {
                if (source[sourceKey] !== null && source[sourceKey] !== undefined && typeof source[sourceKey] === 'object' && !Array.isArray(source[sourceKey])) {
                    target[sourceKey] = this.nestedAssign(target[sourceKey] || {}, source[sourceKey]);
                } else {
                    target[sourceKey] = (sourceKey === 'sender_id' && typeof source[sourceKey] === 'string' && source[sourceKey].match(/^[0-9]+$/) ? parseFloat(source[sourceKey]) : source[sourceKey]);
                }
            });

            return target;
        },
        async getShippingServices() {
            const typesRpository = new NtapsServiceTypesRepository();
            this.services = await typesRpository.getAll();
        },
        showModalAddGoods(shipmentIndex) {
            this.goods_to_add_shipments_index = shipmentIndex;
            this.$bvModal.show('modal-add-goods');
        },
        async removeGoods(shipmentIndex, goodsIndex) {
            let doDelete = false;
            await this.$swal({
                text: 'Är du säker på att du vill ta bort denna vara?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Ja, ta bort!',
            })
                .then((result) => {
                    if (result.isConfirmed) {
                        doDelete = true;
                    }
                });
            if (doDelete) {
                this.print_job.shipments[shipmentIndex].contents.goods.splice(goodsIndex, 1);
            }
        },
        addGoods() {
            this.print_job.shipments[this.goods_to_add_shipments_index].contents.goods.push({ ...this.goods_to_add });
            this.$bvModal.hide('modal-add-goods');
            this.updateCustomsDeclaration(this.goods_to_add_shipments_index);
            this.resetGoodsToAdd();
        },
        setAddGoodsSku(opt) {
            this.resetGoodsToAdd(false);
            const product = new ProductRepository();
            return product.getById(opt.ProdID).then((res) => {
                this.goods_to_add.name = res.name;
                if (res.brand) {
                    this.goods_to_add.brand = res.brand.name;
                }
                if (res.CustomsSourceCountryCode) {
                    this.goods_to_add.country_of_origin = res.CustomsSourceCountryCode;
                }
                if (res.CustomsStatNo) {
                    this.goods_to_add.hs_tariff_number = res.CustomsStatNo;
                }
                // if (res.customs_information.tariff_description) {
                //     this.goods_to_add.category = res.customs_information.tariff_description;
                // }
                if (res.ProdWeight) {
                    this.goods_to_add.unit_gross_weight = res.ProdWeight * 1000;
                }
                if (res.ProdWeight) {
                    this.goods_to_add.unit_value = res.ProdNetPrice;
                }
            });
        },
        resetGoodsToAdd(all = true) {
            if (all) {
                this.goods_to_add_shipments_index = 0;
                this.goods_to_add.quantity = 1;
                this.goods_to_add.sku = null;
            }
            this.goods_to_add.name = '';
            this.goods_to_add.dimensions.width = 10;
            this.goods_to_add.dimensions.height = 10;
            this.goods_to_add.dimensions.length = 10;
            this.goods_to_add.unit_gross_weight = '';
            this.goods_to_add.brand = '';
            this.goods_to_add.category = '';
            this.goods_to_add.country_of_origin = null;
            this.goods_to_add.hs_tariff_number = '';
            this.goods_to_add.unit_value = '';
            this.goods_to_add.currency = 'SEK';
        },
        createCustomsDeclaration(shipmentIndex) {
            this.print_job.shipments[shipmentIndex] = this.nestedAssign(this.print_job.shipments[shipmentIndex], {
                customs: {
                    declaration: {
                        general_customs_declaration: {
                            contents_explanation: 'Home interior products',
                            contents_type: 'SALE',
                            currency: 'SEK',
                            in_co_terms: 'DDP',
                            invoice_date: '',
                            invoice_number: '',
                            seller_tax_id_number: 'SE5565712865',
                            total_gross_weight: 0,
                        },
                    },
                },
            });

            this.updateCustomsDeclaration(shipmentIndex);
        },
        updateCustomsDeclaration(shipmentIndex) {
            if (this.print_job.shipments[shipmentIndex].customs?.declaration) {
                let totalGrossWeight = 0;
                let currency = 'SEK';
                if (this.print_job.shipments[shipmentIndex].customs && this.print_job.shipments[shipmentIndex].contents.goods) {
                    this.print_job.shipments[shipmentIndex].contents.goods.forEach((item) => {
                        if (item.unit_gross_weight && item.quantity) {
                            totalGrossWeight += item.unit_gross_weight * item.quantity;
                        }
                        if (item.currency) {
                            currency = item.currency;
                        }
                    });
                }
                this.print_job.shipments[shipmentIndex].customs.declaration.general_customs_declaration.total_gross_weight = totalGrossWeight;
                this.print_job.shipments[shipmentIndex].customs.declaration.general_customs_declaration.currency = currency;
            }
        },
    },
    computed: {
        service_types() {
            const types = [];
            const added = [];
            const postnord = this.services.find((s) => s.id === 3);
            if (postnord && Array.isArray(postnord.service_types)) {
                postnord.service_types.forEach((type) => {
                    type.delivery_service_id = postnord.id;
                    if (!added.includes(type.name)) {
                        types.push(type);
                        added.push(type.name);
                    }
                });
            }

            this.services.forEach((service) => {
                if (Array.isArray(service.service_types)) {
                    service.service_types.forEach((type) => {
                        type.delivery_service_id = service.id;
                        if (!added.includes(type.name)) {
                            types.push(type);
                            added.push(type.name);
                        }
                    });
                }
            });

            return types;
        },
        old_system_url() {
            return window.config.app.old_system_url;
        },
        order_route() {
            if (this.shipment && this.shipment.internal_data) {
                if (this.shipment.internal_data.internal_reference1 === 1) {
                    return { name: 'prodorders.edit', params: { id: this.shipment.internal_data.internal_reference2 } };
                }
                if (this.shipment.internal_data.internal_reference1 === 2) {
                    return { name: 'returnorder.edit', params: { id: this.shipment.internal_data.internal_reference2 } };
                }
                if (this.shipment.internal_data.internal_reference1 === 3) {
                    return { name: 'cardorders.edit', params: { id: this.shipment.internal_data.internal_reference2 } };
                }
            }

            return null;
        },
    },
};
</script>
